import React from "react";
import { Classes, Dialog } from "@blueprintjs/core";
import { useTranslation } from "react-i18next";
const IEBrowser = () => {
  const { t } = useTranslation();
  return (
    <Dialog
      isOpen
      icon="outdated"
      className="thin-scroolbar"
      title={t("error_ie_browser_header")}
      isCloseButtonShown={false}
      canEscapeKeyClose={false}
      canOutsideClickClose={false}
    >
      <div className={Classes.DIALOG_BODY}>
        <div className="alert alert-danger">{t("error_ie_browser_body")}
        <p>{t("error_ie_browser_body_extra")}</p>
        </div>
      </div>
    </Dialog>
  );
};
export default IEBrowser;
